import React from 'react';
import { Link } from 'react-router-dom';

// Custom SVG Logo for Footer (Matches Header)
const FooterLogo: React.FC<{ className?: string }> = ({ className = "w-10 h-10" }) => (
  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <defs>
      <linearGradient id="footerLogoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#4ADE80" /> {/* Green-400 */}
        <stop offset="50%" stopColor="#22D3EE" /> {/* Cyan-400 */}
        <stop offset="100%" stopColor="#3B82F6" /> {/* Blue-500 */}
      </linearGradient>
    </defs>
    
    <path 
      d="M50 5 L15 18 V45 C15 68 30 88 50 95 C70 88 85 68 85 45 V18 L50 5 Z" 
      fill="none" 
      stroke="url(#footerLogoGrad)" 
      strokeWidth="4" 
      strokeLinejoin="round"
    />
        
    <circle cx="50" cy="45" r="18" stroke="url(#footerLogoGrad)" strokeWidth="4" fill="none"/>
    <line x1="63" y1="58" x2="75" y2="70" stroke="url(#footerLogoGrad)" strokeWidth="6" strokeLinecap="round"/>
    
    <rect x="40" y="35" width="20" height="20" rx="2" stroke="url(#footerLogoGrad)" strokeWidth="2" fill="none"/>
    <path d="M40 40 H36 M40 45 H36 M40 50 H36 M60 40 H64 M60 45 H64 M60 50 H64 M45 35 V31 M50 35 V31 M55 35 V31 M45 55 V59 M50 55 V59 M55 55 V59" 
          stroke="url(#footerLogoGrad)" strokeWidth="2" strokeLinecap="round"/>
    <rect x="45" y="40" width="10" height="10" rx="1" fill="url(#footerLogoGrad)" fillOpacity="0.4"/>
  </svg>
);

const Footer: React.FC = () => {
  return (
    <footer className="bg-secondary text-white">
      <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div>
            <h3 className="text-2xl font-bold flex items-center gap-3 text-white">
              <FooterLogo className="w-8 h-8" />
              ChargesDecoder
            </h3>
            <p className="max-w-xs mt-4 text-sm text-gray-400">
              Demystifying finance, one charge at a time. We help you decode bank statements, compare fees, and save money.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 lg:col-span-2 sm:grid-cols-3">
            <div>
              <p className="font-semibold text-white">Platform</p>
              <nav className="flex flex-col mt-4 space-y-2 text-sm text-gray-400">
                <Link to="/" className="hover:text-primary transition-colors">Home</Link>
                <Link to="/charges" className="hover:text-primary transition-colors">All Charges</Link>
                <Link to="/compare" className="hover:text-primary transition-colors">Comparison Tool</Link>
                <Link to="/bank-charges" className="hover:text-primary transition-colors">Banks Directory</Link>
              </nav>
            </div>
            
            <div>
              <p className="font-semibold text-white">Resources</p>
              <nav className="flex flex-col mt-4 space-y-2 text-sm text-gray-400">
                <Link to="/faq" className="hover:text-primary transition-colors">FAQ</Link>
                <Link to="/privacy-policy" className="hover:text-primary transition-colors">Privacy Policy</Link>
                <a href="#" className="hover:text-primary transition-colors">Terms of Service</a>
                <a href="mailto:chargesdecoder@gmail.com" className="hover:text-primary transition-colors">Contact Us</a>
              </nav>
            </div>
            
            <div>
              <p className="font-semibold text-white">About</p>
              <div className="flex flex-col mt-4 space-y-2 text-sm text-gray-400">
                <p>Data sourced from official banking documents and updated regularly.</p>
                <div className="pt-2">
                    <p className="font-semibold text-white text-xs uppercase tracking-wider mb-1">Contact</p>
                    <a href="mailto:chargesdecoder@gmail.com" className="hover:text-primary transition-colors block break-all">chargesdecoder@gmail.com</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 mt-8 border-t border-gray-800 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500">
            © 2025 ChargesDecoder. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;